module.exports = __webpack_public_path__ + "static/media/icon-header-projects.1e42a519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-projects.svg
// module id = 1511
// module chunks = 193